import React, { ReactElement } from "react";

function PaypalIcon(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="52.427"
      height="12.702"
      viewBox="0 0 52.427 12.702"
    >
      <g id="paypal-seeklogo.com" transform="translate(-0.001)">
        <path
          id="Path_9937"
          data-name="Path 9937"
          d="M173.192,386.87h3.583c1.924,0,2.648.974,2.536,2.4-.185,2.362-1.613,3.669-3.507,3.669h-.956c-.26,0-.435.172-.5.638l-.406,2.71c-.027.176-.119.277-.258.291h-2.251c-.212,0-.287-.162-.231-.512l1.372-8.686A.546.546,0,0,1,173.192,386.87Z"
          transform="translate(-168.616 -383.88)"
          fill="#009ee3"
          fillRule="evenodd"
        />
        <path
          id="Path_9938"
          data-name="Path 9938"
          d="M314.677,385.13a1.964,1.964,0,0,1,2.171,2.29c-.185,1.942-1.225,3.017-2.867,3.021h-1.434c-.206,0-.306.168-.36.513l-.277,1.764c-.042.266-.178.4-.38.4H310.2c-.213,0-.287-.136-.24-.44l1.1-7.068c.055-.348.185-.477.423-.477h3.194Zm-2.173,3.784h1.087c.68-.026,1.131-.5,1.176-1.346a.821.821,0,0,0-.89-.9l-1.023,0-.35,2.238Zm7.973,3.66c.122-.111.246-.168.228-.031l-.043.327c-.022.171.045.262.2.262h1.186c.2,0,.3-.08.346-.389l.731-4.585c.037-.23-.019-.343-.194-.343h-1.3c-.117,0-.175.066-.205.245l-.048.282c-.025.147-.092.173-.155.025-.221-.523-.785-.758-1.572-.74a3.263,3.263,0,0,0-3.193,3.205,2.2,2.2,0,0,0,2.184,2.457,2.345,2.345,0,0,0,1.84-.712h0Zm-.993-.706a1.192,1.192,0,0,1-1.222-1.4,1.7,1.7,0,0,1,1.637-1.4,1.192,1.192,0,0,1,1.222,1.4,1.7,1.7,0,0,1-1.637,1.4Zm5.965-4.069h-1.2c-.248,0-.349.185-.27.412l1.493,4.371L324,394.663c-.123.174-.028.332.145.332H325.5a.413.413,0,0,0,.4-.2l4.591-6.585c.142-.2.075-.415-.157-.415h-1.279c-.219,0-.307.087-.433.269l-1.914,2.774-.855-2.781a.366.366,0,0,0-.405-.261Z"
          transform="translate(-294.547 -382.301)"
          fill="#113984"
          fillRule="evenodd"
        />
        <path
          id="Path_9939"
          data-name="Path 9939"
          d="M537.346,385.112a1.964,1.964,0,0,1,2.171,2.29c-.185,1.942-1.225,3.017-2.867,3.021h-1.433c-.206,0-.306.168-.36.513l-.277,1.764c-.042.266-.179.4-.38.4h-1.334c-.213,0-.287-.136-.24-.44l1.1-7.07c.055-.348.185-.477.423-.477h3.194Zm-2.173,3.784h1.087c.68-.026,1.131-.5,1.176-1.346a.821.821,0,0,0-.89-.9l-1.023,0-.351,2.238Zm7.973,3.66c.122-.111.246-.168.228-.031l-.043.327c-.022.171.045.262.2.262h1.186c.2,0,.3-.08.346-.389l.731-4.585c.037-.23-.02-.343-.194-.343h-1.3c-.117,0-.175.066-.205.245l-.048.282c-.025.147-.092.173-.155.025-.221-.523-.785-.758-1.572-.74a3.263,3.263,0,0,0-3.193,3.205,2.2,2.2,0,0,0,2.184,2.457,2.345,2.345,0,0,0,1.84-.712h0Zm-.992-.706a1.192,1.192,0,0,1-1.222-1.4,1.7,1.7,0,0,1,1.637-1.4,1.192,1.192,0,0,1,1.222,1.4,1.7,1.7,0,0,1-1.637,1.4Zm5.468,1.271h-1.369a.162.162,0,0,1-.167-.185l1.2-7.617a.236.236,0,0,1,.227-.185h1.369a.162.162,0,0,1,.167.185l-1.2,7.617a.236.236,0,0,1-.227.187Z"
          transform="translate(-496.625 -382.283)"
          fill="#009ee3"
          fillRule="evenodd"
        />
        <path
          id="Path_9940"
          data-name="Path 9940"
          d="M145.816,354.54H149.4a4.482,4.482,0,0,1,3.009.74,2.431,2.431,0,0,1,.752,2.034c-.22,2.738-1.858,4.273-4.055,4.273H147.34c-.3,0-.5.2-.585.74l-.494,3.144c-.032.2-.12.324-.277.338H143.77c-.245,0-.332-.185-.268-.594l1.591-10.078A.636.636,0,0,1,145.816,354.54Z"
          transform="translate(-143.48 -354.54)"
          fill="#113984"
          fillRule="evenodd"
        />
        <path
          id="Path_9941"
          data-name="Path 9941"
          d="M179.43,391.339l.626-3.965a.548.548,0,0,1,.624-.514h3.583a3.494,3.494,0,0,1,1.448.264c-.36,2.438-1.936,3.792-4,3.792h-1.765A.522.522,0,0,0,179.43,391.339Z"
          transform="translate(-176.104 -383.871)"
          fill="#172c70"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default PaypalIcon;
